export default __webpack_public_path__ + "static/media/0.1a21e34a.png";